import React, { FC, useEffect } from 'react'
import LastLookModal from '../../components/Modal/LastLookModal/LastLookModal'
import { useOpenFin } from '../../helpers/hooks/useOpenFin'
import { useAppSelector } from '../../store/types'
import { getLastLookWindows } from '../../store/windows/selectors'
import { SecurityModalInfo } from '../../store/windows/types'
import Popout from '../Popouts/Popout'

const LastLookOpener: FC = () => {
  const { isOpenFin, openPlatformWindow } = useOpenFin()
  const lastLookWindows = useAppSelector(getLastLookWindows)

  useEffect(() => {
    if (!isOpenFin) return
    lastLookWindows.forEach((windowInfo: SecurityModalInfo) => {
      openPlatformWindow(`LastLook/${windowInfo.orderId}`)
    })
  }, [isOpenFin, lastLookWindows, openPlatformWindow])

  if (isOpenFin || lastLookWindows.length === 0) return null
  return (
    <>
      {lastLookWindows.map((windowInfo: SecurityModalInfo) => (
        <Popout
          key={windowInfo.orderId}
          title={`LastLook/${windowInfo.orderId}`}
          windowInfo={windowInfo}
        >
          <LastLookModal key={windowInfo.orderId} windowInfo={windowInfo} />
        </Popout>
      ))}
    </>
  )
}

export default LastLookOpener
